import clsx from 'clsx';
import type { FC } from 'react';

import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      {/* Card 1854540586736944835 — o `Logo1Icon` era a marca-símbolo do AFFiNE, e ficava
          coladinha no título da tela de login: o último lugar em que a marca antiga aparecia
          depois de o endereço, a aba, o `serverConfig` e o manifest já dizerem Mirezi.

          ⚠️ **Ela SAI em vez de ser trocada, e isso é decisão declarada (D5).** Não há arte de
          Mirezi; um símbolo provisório teria vida longa, e um caminho de imagem quebrado
          mostraria um retângulo vazio. O título sozinho é honesto — a identidade da tela vem
          do nome, que agora está certo em três lugares dela. */}
      <p>{title}</p>
      <p>{subTitle}</p>
    </div>
  );
};
